
import { ChevronDownIcon } from 'vue-feather-icons'

export default {
  name: 'AccordionSingle',
  components: { ChevronDownIcon },
  props: {
    openInit: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    open: false
  }),
  created () {
    this.open = this.openInit
  },
  methods: {
    toggle () {
      this.open = !this.open
      this.$emit('toggle')
    }
  }
}
